import { useState } from "react";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";
import {
  DivCharacterNav,
  DivCharacterRelateContainNav,
} from "../style/CharacterRelateContainNav.style";
import CharacterContainNavCharList from "../CharacterContainNavCharList";
import WordExpressionContainTypeNav from "./WordExpressionContainTypeNav";
import RadicalCharacterRelateContainNav from "../RadicalCharacter/RadicalCharacterRelateContainNav";

type WordExpressionRelateContainNavProps = {
  character: CharacterResult;
};

const WordExpressionRelateContainNav = ({
  character,
}: WordExpressionRelateContainNavProps) => {
  const [navCharacter, setNavCharacter] = useState<CharacterResult | null>(
    null
  );
  const [navLetterList, setNavLetterList] = useState<CharacterLetter[]>([]);

  const navCharacterHandle = (letters: CharacterLetter[]) => {
    setNavLetterList(letters);
    // console.log("navCharacterHandle - letters.length", letters.length);

    if (navCharacter !== null) {
      setNavCharacter(null);
    }
  };

  return (
    <DivCharacterRelateContainNav>
      <WordExpressionContainTypeNav
        character={character}
        lettersGetHandle={navCharacterHandle}
      />
      {navLetterList && (
        <DivCharacterNav>
          <CharacterContainNavCharList
            navLetterList={navLetterList}
            navCharacterHandle={setNavCharacter}
            navCharacter={navCharacter}
          />
        </DivCharacterNav>
      )}
      {navCharacter !== null && (
        <RadicalCharacterRelateContainNav character={navCharacter} />
      )}
    </DivCharacterRelateContainNav>
  );
};

export default WordExpressionRelateContainNav;
